import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { history } from '../../../helpers';
import '../../../content/css/ContractReviewer.css';
import { contractReviewerActions as actions } from '../../../actions';
import DocumentListItem from './DocumentListItem';
import ConfirmationModal from '../../Misc/ConfirmationModal';

class DocumentList extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedDocId: null,
            showDeleteConfirmationModal: false
        };
    }

    handleItemClick = (docId) => {
        let selectedDocId = this.state.selectedDocId != docId ? docId : null;
        this.setState({ selectedDocId });
    }

    handleItemReview = (docId) => {
        if (this.state.selectedDocId)
            history.push(`/${this.state.selectedDocId}`);
    }

    handleItemDelete = (docId) => {
        this.setState({ showDeleteConfirmationModal: true });
    }

    handleModalDeleteConfirm = () => {
        if (this.state.selectedDocId)
            this.props.deleteDocument(this.state.selectedDocId);

        this.setState({ showDeleteConfirmationModal: false, selectedDocId: null });
    }

    handleModalDeleteClose = () => {
        this.setState({ showDeleteConfirmationModal: false });
    }

    renderItems() {
        return this.props.items.map((doc, i) => (
            <DocumentListItem
                id={doc.id}
                filename={doc.fileName}
                date={doc.wasSaved}
                isSelected={doc.id == this.state.selectedDocId}
                onClick={this.handleItemClick}
                onReview={this.handleItemReview}
                onDelete={this.handleItemDelete}
            />
        ));
    }

    render() {
        return (
            <React.Fragment>
                <div className="pages">
                    {this.renderItems()}
                </div>
                <ConfirmationModal
                    show={this.state.showDeleteConfirmationModal}
                    warningText="Are you sure you want to delete this document?"
                    onConfirm={this.handleModalDeleteConfirm}
                    onClose={this.handleModalDeleteClose}
                />
            </React.Fragment>
        );
    }
}

export default connect(
    state => state.contractReviewer,
    dispatch => bindActionCreators(actions, dispatch)
)(DocumentList);



// WEBPACK FOOTER //
// ./src/components/Home/DocumentList/DocumentList.js